<template>
<div class="plantGrass-ui" :style="componentBgColor">
    <div class="notesList waterfall">
        <waterfall :col="col" :data="notesList" :width="itemWidth">
            <template>
                <div v-for="(item,i) in notesList" :key="i" class="goods-box">
                    <div class="goods-box-box" @click="goPlantingNotesInfo(item)" :style="style">
                        <div class="img-box">
                            <img class="img" :lazy-src="item.videoCover + '?imageMogr2/thumbnail/334x'"  v-if="!item.pictureUrl&&item.videoUrl">
                            <img class="img" :lazy-src="item.logo+'?imageMogr2/thumbnail/334x'" v-else/>
                            <div class="play_btn" v-if="!item.pictureUrl&&item.videoUrl">
                                <i  class="iconfont iconplay"></i>
                            </div>
                        </div>
                        <div class="goods-content-common">
                            <div class="goods-name">{{item.title}}</div>
                            <div class="goods-bottom">
                                <div class="head_img">
                                    <img :src="item.avatar">
                                    <div class="user_name">{{item.authorName}}</div>
                                </div>
                                <div class="zan" @click.stop="shopPlantingNotesLike(item)" v-if="item.canNotLike!='T'">
                                    <i class="iconfont iconzan-xian" v-if="item.likeId==''"></i>
                                    <i class="iconfont iconzan-mian" v-else></i>
                                    {{item.liker}}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </waterfall>
    </div>
    <div class="more">
        <div class="more_btn" @click="goPlantingNotesList()" v-if="finalDatas.more">点击查看更多<i class="iconfont icongengduo1"></i></div>
    </div>
</div>
</template>

<script>
// 标题
import api from "@/utils/api";
import {
    setStorage,
    getStorage
} from "@/utils/wxuser";
import {
    jAlert3,
    jAlert5
} from '@/base/jAlert/jAlert';
import {
    urlEncode
} from '@/utils/index';
var config = {};
export default {
    name: "plantGrass",
    data() {
        return {
            finalDatas: {},
            notesList: [],
            user: '',
            wxuser: '',
            canRequest: true

        };
    },
    props: {
        datas: Object
    },
    computed: {
        componentBgColor() {
				return `background:${this.finalDatas.componentBgColor};`
			},
        style() {
            var style = ''
            if (this.finalDatas.borderType == 'circular') {
                style += `border-radius: 0.106667rem;`
            }
            if (this.finalDatas.shadowType == 'shadow') {
                style += `box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);`
            }
            return style;
        },
        itemWidth() {
            return (167 * (document.documentElement.clientWidth / 375))
        },

    },
    methods: {
        goPlantingNotesList(item) {
            this.$router.push({
                path: '/plantingNotes'

            })
        },
        goPlantingNotesInfo(item) {
            this.$router.push({
                path: '/plantingNotesInfo',
                query: {
                    id: item.id
                }
            })
        },
        cancelShopPlantingNotesLike(item) {
            var opt = {
                hotelGroupCode: config.hotelGroupCode,
                hotelCode: config.hotelCode,
                id: item.id,
                likeId: item.likeId,
                openid: this.wxuser.openid,
                memberId: this.user.memberId
            }
            api.cancelShopPlantingNotesLike(opt).then(res => {
                if (res.result == 1) {
                    item.liker--;
                    item.likeId = ''
                    jAlert3('取消成功')
                } else {
                    jAlert3(res.msg)
                }
                this.canRequest = true
            })
        },
        shopPlantingNotesLike(item) {
            if (!this.canRequest) {
                return false
            }
            this.canRequest = false
            if (!this.user || !this.user.memberId) {
                this.isLogin()
            } else {
                if (item.likeId && item.likeId != '') {
                    this.cancelShopPlantingNotesLike(item)
                } else {
                    var opt = {
                        hotelGroupCode: config.hotelGroupCode,
                        hotelCode: config.hotelCode,
                        id: item.id,
                        openid: this.wxuser.openid,
                        memberId: this.user.memberId
                    }
                    api.shopPlantingNotesLike(opt).then(res => {
                        if (res.result == 1) {
                            item.liker++;
                            item.likeId = res.msg
                            jAlert3('点赞成功')
                        } else {
                            jAlert3(res.msg)
                        }
                        this.canRequest = true
                    })
                }

            }
        },
        getShopPlantingNotesInfoList() {

            var opt = {
                hotelGroupCode: config.hotelGroupCode,
                openid: this.wxuser.openid,
                memberId: this.user.memberId,
                ids: this.finalDatas.plantGrassIds.join(',')
            }

            api.getShopPlantingNotesInfoList(opt).then((res) => {
                if (res.result == 1) {
                    this.finalDatas.plantGrassIds.forEach(note => {
                        res.retVal.forEach(item => {
                            if (item.id == note) {
                                if (this.notesList.length < this.finalDatas.maxnum) {
                                    let pictureUrl = JSON.parse(item.pictureUrl)
                                    if (item.videoUrl&&(!pictureUrl||pictureUrl.length<=0)){
                                    item.logo = item.videoCover
                                    }
                                    else if (item.pictureUrl) {
                                    item.logo = JSON.parse(item.pictureUrl)[0]
                                    }
                                    
                                    this.notesList.push(item)
                                }

                            }
                        })
                    })

                } else {
                    jAlert3(res.msg);
                }
            })
        }

    },
    created() {
        this.user = getStorage('user');
        this.wxuser = getStorage('wxuser');
        config = getStorage('config');
    },
    mounted() {
        this.listShopPlantingNotesAuthor();
        this.finalDatas = JSON.parse(JSON.stringify(this.datas));
        console.log(this.finalDatas)
        this.getShopPlantingNotesInfoList()
    }
};
</script>

<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.plantGrass-ui {
    padding: 0 0.4rem;

    .waterfall {
        padding-top: 0.4rem;

        .goods-box {
            padding-bottom: 0.4rem;
            display: flex;
        }

        .goods-box-box {
            position: relative;
            width: 4.453333rem;
            background: #fff;
            overflow: hidden;
            display: inline-block;

            height: 100%;
            box-sizing: border-box;

            .img-box {
                overflow: hidden;

                position: relative;
                width: 4.453333rem;
                position: relative;

                .img {
                    width: 100%;
                    height: 100%;

                }
                .play_btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    
                    height: 10px;
                    width: 10px;
                    color: #fff;
                    cursor: pointer;
                    background: rgba(0, 0, 0, 0.5);
                    padding: 10px;
                    border-radius: 50%;

                    .iconfont {
                        margin-left: 2px;
                        font-size: 8px;
                    }
                }

            }

            .goods-content-common {
                padding: 0.213333rem 0.266667rem 0.266667rem;

                .goods-name {
                    font-size: 14px;
                    color: #333333;
                    font-family: PingFangSC-Regular;
                    text-align: left;
                    line-height: 0.533333rem;
                    max-height: 1.066667rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    white-space: normal;
                    overflow: hidden;
                    color: #333333;
                }

                .goods-bottom {
                    margin-top: 0.213333rem;
                    align-items: center;
                    display: flex;
                    justify-content: space-between;

                    .head_img {
                        display: flex;
                        flex: 1;
                        align-items: center;

                        img {
                            height: 0.4rem;
                            width: 0.4rem;
                            border-radius: 50%;
                        }

                        .user_name {
                            margin-left: 0.133333rem;
                            font-size: 12px;
                            color: #999999;
                            height: 0.4rem;
                            line-height: 0.4rem;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            white-space: normal;
                            overflow: hidden;
                        }
                    }

                    .zan {
                        display: flex;
                        align-items: center;
                        font-size: 12px;
                        color: #333333;

                        i {
                            color: #999;
                            font-size: 12px;
                            margin-right: 0.053333rem;

                            &.iconzan-mian {
                                color: #F44400;
                            }
                        }
                    }
                }
            }

        }
    }

    .more {
        display: flex;
        justify-content: center;

        .more_btn {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0.213333rem 0.533333rem;
            background: #FFFFFF;
            border: 1px solid #F2F2F2;
            border-radius: 0.426667rem;

            i {
                color: #999;
                font-size: 10px;
                margin-left: 0.133333rem;
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/plantGrass.vue